<template>
    <div>
        <form>
            <div class="form-row">
                <div class="col">
                    <label>Add Question Here.</label>
                    <el-input v-model="inputQuestion"></el-input>
                </div>
            </div>
            <div class="form-row">
                <div class="col-2">
                    <label>Ordering Number.</label>
                    <el-input v-model="inputQuestionOrdering"></el-input>
                    <el-button v-on:click="insertEnrolmentQuestion()">ADD</el-button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    export default {
        name: "AddEnrolmentQuestion",
        data(){
            return{
                inputQuestion:'',
                inputQuestionOrdering:'',
            }
        },

        methods:{
            async insertEnrolmentQuestion(){
                const resp = await DataSource.shared.insertEnrolmentQuestion(this.inputQuestion, this.inputQuestionOrdering);
                if(resp){
                    console.log('resp=',resp);
                }
            },
        },
    }
</script>

<style scoped>

</style>